module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"common-carousel\" class=\"carousel slide\" data-interval=\"false\">\r\n    <div class=\"carousel-inner\">\r\n        <div class=\"item active\">\r\n            <div draggable=\"true\" id=\"workflow_stage\" class=\"col-sm-1 nopadding factory-widget\">\r\n                <div class=\"thumb ui-widget-header\">\r\n\r\n                    <div class=\"row itemIcon\">\r\n                        <i class=\"fa pf-stage\"></i>\r\n                        </div>\r\n                        <div class=\"row itemName\">\r\n                            <p>Stage</p>\r\n                        </div>\r\n                </div>\r\n            </div>\r\n            <div draggable=\"true\" id=\"workflow_comment\" class=\"col-sm-1 nopadding factory-widget\">\r\n                <div class=\"thumb ui-widget-header\">\r\n\r\n                    <div class=\"row itemIcon\">\r\n                        <i class=\"fa pf-comment\"></i>\r\n                        </div>\r\n                        <div class=\"row itemName\">\r\n                            <p>Comment</p>\r\n                        </div>\r\n                   \r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}